export default __webpack_public_path__ + "cd7e5790d814774d3068dd1cc3164734.svg";